import PageHeader from "@/components/PageHeader";
import Footer from "@/components/Footer";
import Founders from "@/components/Founders";

export default function Leadership() {
  return (
    <div className="min-h-screen bg-[#FBF9F5]">
      <PageHeader />
      <div className="pt-16 sm:pt-20" data-testid="leadership-page">
        <Founders />
      </div>
      <Footer />
    </div>
  );
}
